import Vue from 'vue';
import Vuex from 'vuex';

import addresses from './modules/addresses';
import auth from './modules/auth';
import billboard from './modules/billboard';
import cart from './modules/cart';
import checkout from './modules/checkout';
import dispatchPortal from './modules/dispatchPortal';
import orders from './modules/orders';
import pendingOrders from './modules/pendingOrders';
import profile from './modules/profile';
import utils from './modules/utils';
import navbar from './modules/navbar';
import contact from './modules/contact';
import warehouseOrder from './modules/warehouseOrder'


Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    addresses,
    auth,
    billboard,
    cart,
    checkout,
    dispatchPortal,
    orders,
    pendingOrders,
    profile,
    utils,
    navbar,
    contact,
    warehouseOrder,
  },
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js